<div class="row">
  <!-- <ngb-alert type="success" (close)="successMessage = null">Saved Details</ngb-alert> -->
<div class="col-md-12">
  <h2>Candidate Registration Instructions</h2>
</div>
</div>
<app-home-card-config [contenttype]="'candidate_inst'">
  
</app-home-card-config>

<br>
<hr>
<br>

<div class="row">
  <!-- <ngb-alert type="success" (close)="successMessage = null">Saved Details</ngb-alert> -->
<div class="col-md-12">
  <h2>Candidate Dashboard Instructions</h2>
</div>
</div>
<app-home-card-config [contenttype]="'dashboard_inst'">
  
</app-home-card-config>


<br>
<hr>
<br>

<div class="row">
  <!-- <ngb-alert type="success" (close)="successMessage = null">Saved Details</ngb-alert> -->
<div class="col-md-12">
  <h2>Candidate Profile Instructions</h2>
</div>
</div>
<app-home-card-config [contenttype]="'profile_inst'">
  
</app-home-card-config>